import styles from "./NavBar.module.css";
import GenericNavItem from "../GenericNavItem";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../router/routes";
import NavigateBackItem from "./NavigateBackItem";
import { useConfig } from "../../context/ConfigContext";
import { useClientAccessContext } from "../../context/ClientAccessContext";
import GenericSortItem from "../GenericSortItem";
import { PanelId } from "../../context/PanelContext";
import { SignInButton } from "../PageLayout/SignInButton";
import { useIsAuthenticated } from "@azure/msal-react";
import GenericInputField from "../GenericInputField";
import SearchIcon from "@mui/icons-material/Search";
import { useDocuments } from "../../context/DocumentContext";
import GenericButton from "../GenericButton";
import OpenBasketButton from "../OpenBasketButton";

export enum IconPath {
	Burger = "M15.1 1.5a.9.9 0 0 1 .062 1.798L15.1 3.3H.9a.9.9 0 0 1-.062-1.798L.9 1.5h14.2zM8 7.1a.9.9 0 0 1 .062 1.798L8 8.9H.9a.9.9 0 0 1-.062-1.798L.9 7.1H8zm3.4 5.6a.9.9 0 0 1 .062 1.798l-.062.002H.9a.9.9 0 0 1-.062-1.798L.9 12.7h10.5z",
	ArrowDown = "M7.992 0c.479 0 .87.37.902.838L8.897.9v12.198l2.917-2.573c.886-.782 2.06.506 1.244 1.306l-.045.041-4.421 3.9a.89.89 0 0 1-.814.201l-.053-.015-.053-.018-.044-.018-.057-.027-.048-.027-.047-.03a.916.916 0 0 1-.087-.068l-.03-.028-4.388-3.87a.897.897 0 0 1-.12-1.218l.043-.052a.908.908 0 0 1 1.225-.12l.052.043 2.917 2.573V.9c0-.476.372-.866.842-.898L7.992 0z",
}

const isRouteWithTopicNavBack = (pathname: string) => {
	return [routes.overview, routes.admin, routes.report].includes(pathname);
};

const Navbar = () => {
	const isAuthenticated = useIsAuthenticated();
	const {
		selectedTopic,
		usersTopics,
		loadingCategories,
		searchQuery,
		setSearchQuery,
	} = useConfig();
	const { selectedClient, userWithClients } = useClientAccessContext();
	const [leftItem, setLeftItem] = useState(null);
	const [rightItem, setRightItem] = useState(null);
	const [showQuickQuery, setShowQuickQuery] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();

	const handleInputText = (value: string) => {
		setSearchQuery((prevQuery) => {
			return {
				...prevQuery,
				includeText: value,
			};
		});
	};
	useEffect(() => {
		setShowQuickQuery(false);
		if (
			location.pathname === routes.selectTopic &&
			userWithClients?.clientAccesses.length > 0
		) {
			setLeftItem(
				<NavigateBackItem
					text={selectedClient?.clientName}
					route={routes.selectClient}
					canNavigateBack={canNavigateBack(routes.selectClient)}
				/>,
			);
			setRightItem(null);
		} else if (
			isRouteWithTopicNavBack(location.pathname) &&
			userWithClients?.clientAccesses.length > 0 &&
			usersTopics.length > 0
		) {
			location.pathname !== routes.admin && setShowQuickQuery(true);
			setLeftItem(
				<NavigateBackItem
					text={selectedTopic?.name}
					route={routes.selectTopic}
					canNavigateBack={canNavigateBack(routes.selectTopic)}
				/>,
			);
			location.pathname === routes.overview
				? setRightItem(
						<div style={{ display: "flex" }}>
							<OpenBasketButton />
							<GenericSortItem />
						</div>,
				  )
				: setRightItem(null);
		} else {
			setLeftItem(<div />);
			setRightItem(null);
		}
	}, [location.pathname, selectedTopic, selectedClient]);

	const canNavigateBack = (route: string) => {
		if (route === routes.selectTopic)
			return (
				usersTopics?.length > 1 || userWithClients?.clientAccesses?.length > 1
			);
		if (route === routes.selectClient)
			return userWithClients?.clientAccesses?.length > 1;
		return false;
	};

	return (
		<nav className={styles.navBar}>
			<div className={styles.navContainer}>
				<img
					className={styles.logo}
					src="/logo.svg"
					alt="Logo"
					onClick={() => navigate(routes.overview)}
				/>
				{isAuthenticated ? (
					<>
						<div className={styles.navItems}>
							{leftItem && (
								<div className={styles.leftItem}>
									{leftItem}
									{
										// TODO: bring back when vector db is fixed
										/* {showQuickQuery && (
										<div className={styles.quickQueryInput}>
											<SearchIcon sx={{ fontSize: "18px", color: "#9ea0a5" }} />
											<GenericInputField
												currentValue={searchQuery.includeText}
												placeholder={"Include query text"}
												onValueChange={(v) => handleInputText(v)}
											/>
										</div>
									)} */
									}
								</div>
							)}
							{!loadingCategories && rightItem && (
								<div className={styles.rightItem}>{rightItem}</div>
							)}
						</div>
						<GenericNavItem
							iconPath={IconPath.Burger}
							panelId={PanelId.Navigation}
						/>
					</>
				) : (
					<SignInButton />
				)}
			</div>
		</nav>
	);
};

export default Navbar;
